import React, { useEffect, useState, useRef, Suspense, lazy } from "react"
import { Modal } from "react-bootstrap"
import { Metodos, ComisionesPago } from 'utils/constantes'
import { ListarMetodosPagoActivos } from 'utils/ConfiguracionPagosQuery'
// PERF: svgseleccion.js pesa ~2.8MB (todos los mapas de venues); se carga solo cuando este
// modal realmente se abre, en vez de ir en el bundle inicial de la tienda publica.
const SvgselectView = lazy(() => import("views/Pages/Svgviewa/svgseleccion.js"));
import { GetMetodo, GetValores, getVerTienda, EliminarByStora, EliminarSillaLocal } from "utils/CarritoLocalStorang"
import { metaIniciarCompra } from "utils/metaPixel"
import { useDispatch, useSelector } from "react-redux"
import { cargarmapa, settypo, filtrarlocali } from "StoreRedux/Slice/mapaLocalSlice"
import { clearSillas, cargarsilla } from "StoreRedux/Slice/sillasSlice"
import SweetAlert from 'react-bootstrap-sweetalert';
import { GetEstadousu } from "utils/CarritoLocalStorang"
import { listaEliminasillas } from "utils/CarritoLocalStorang"
import { quitarsilla } from "utils/Querypanelsigui"
import { setModal } from "StoreRedux/Slice/SuscritorSlice"
import { clienteInfo, UpdateDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag"
import { localidaandespacio } from "utils/Querypanel"
import { getDatosUsuariosLocalStorag } from "utils/DatosUsuarioLocalStorag"
import { correlativosadd } from "utils/Querypanelsigui"
import { setToastes } from "StoreRedux/Slice/ToastSlice"
import { mensajeParesX2 } from "utils/paresX2"
import { aplicarOpcion, opcionDelCarrito, opcionesDe, textoOpcion } from "utils/opcionesCompra"
import { updateboletos } from "StoreRedux/Slice/SuscritorSlice"
import { Listarticketporestado } from "utils/userQuery"
import { Eventoid } from "utils/constantes"
import { Triangle } from "react-loader-spinner"
import { bancos } from "utils/Imgenesutils"
import moment from "moment"
import { logWithCallback } from "utilsstile.js/style"
import { AxioBoleteria } from "utils/index"
let { atencion } = bancos
// Imagen de division por bloques del mapa, solo para eventos puntuales donde
// el SVG no muestra bien la division de localidades (ej. ANUEL BOX BLOQUE A/B/C/D).
// Ahora se guarda por evento en la BD (ver imagenBloquesDB / api/v1/imagenBloques
// en el admin, Evetoespecifico.js). Este mapa queda solo de respaldo para
// eventos viejos que se cargaron antes de que existiera esa pantalla.
const EVENTOS_IMAGEN_BLOQUES = {
    "4K93VK": "https://inbox.send.ec/api/upload?file=image/whatsapp-image-1786744836597.jpg"
}
const ModalCarritoView = (prop) => {
    var usuario = getDatosUsuariosLocalStorag()
    const { handleClosesop, precios, setListarCarritoDetalle, intervalo, } = prop
    const sorter = (a, b) => a.precio_normal > b.precio_normal ? 1 : -1 && a.id < b.id ? 1 : -1;
    let estdo = sessionStorage.getItem("estadoevento")
    let CODIGO = sessionStorage.getItem("eventoid")
    let usedispatch = useDispatch()
    let sleccionlocalidad = useSelector((state) => state.SuscritorSlice.boletos)
    let seleciondesillas = useSelector((state) => state.sillasSlice.sillasSelecionadas)
    const modalshow = useSelector((state) => state.SuscritorSlice.modal)
    const [detalle, setDetalle] = useState([])
    const [alert, setAlert] = useState(null)
    const [spinervi, setSpiner] = useState("d-none")
    const [showImagenBloques, setShowImagenBloques] = useState(false)
    const [imagenBloquesDB, setImagenBloquesDB] = useState(null)
    const [checked, setChecked] = useState({
        Efectivo: "",
        Fisico: "",
        Tarjeta: "",
        Deposito: "",
        Transferencia: ""
    })
    const [select, setSelecte] = useState("")
    const [listaPrecio, ListaPrecioset] = useState({
        total: 0,
        subtotal: 0,
        comision: 0,
        comision_bancaria: 0
    })
    const logLocalidadDebug = (paso, payload) => {
        console.log(`[ModalCarritov][${paso}]`, payload)
        logWithCallback({ modulo: "ModalCarritov", paso, ...payload }, "info")
    }
    const handleContinuar = () => {
        // Numeradas x2: sillas de a pares en la misma mesa antes de pagar
        const avisoX2 = mensajeParesX2(seleciondesillas)
        if (avisoX2) {
            usedispatch(setToastes({ show: true, message: avisoX2, color: 'bg-warning', estado: 'Sillas de a pares' }))
            return
        }
        let user = getDatosUsuariosLocalStorag()
        if (clienteInfo() != null) {
            usedispatch(setModal({ nombre: 'ModalDetalle', estado: '' }))
            return
        }
        else {
            // Pixel de Meta: el cliente confirmo sus entradas y pasa a pagar (apagado / sin permiso no hace nada)
            try { metaIniciarCompra(JSON.parse(sessionStorage.getItem("infoevento") || "null"), getVerTienda()) } catch (_e) { }
            usedispatch(setModal({ nombre: 'formasPago', estado: '' }))
            return
        }
    }
    const [check, setCheck] = useState(true)
    // Metodos locales (Efectivo-Local/Tarjeta-Local/Efectivo-QR/Transferencia/
    // Efectivo) que este vendedor puede usar -- null mientras carga o si la
    // consulta falla (se muestran todos, mismo respaldo que usa
    // ModalFormasPago.js para las pasarelas PagoPlux/Payphone/Duna). Sale de
    // metodos_pago_activos: si al vendedor se le restringio algo desde
    // Editar usuario, el backend ya devuelve SOLO esos; si no tiene
    // restriccion, devuelve el catalogo completo -- por eso se filtra por
    // presencia en la respuesta, no por su flag `activo` (ese es un
    // interruptor global aparte, que por ahora no se usa para ocultar nada
    // acá -- solo la restriccion por vendedor filtra).
    const [metodosActivos, setMetodosActivos] = useState(null)
    const esElegibleDescuentoSRI = () => {
        const user = getDatosUsuariosLocalStorag()
        const edadNum = Number(user?.edad)
        const esTerceraEdad = Number.isFinite(edadNum) && edadNum >= 65
        return user?.discapacidad == 'Si' || esTerceraEdad
    }
    function handelMetodopago(target, value) {
        if (target.name == "selctmet") {
            setSelecte(target.value)
            let names = target.value.replace("Efectivo-Local", "Fisico")
            setChecked({
                [names]: target.value,
            })
            sessionStorage.setItem(Metodos, target.value)
        } else {
            setChecked({
                [target.name]: value,
            })
            setSelecte(value)
            sessionStorage.setItem(Metodos, value)
            setCheck(false)
        }

    }
    const checkds = useRef(null)
    function CambiarCheck(e) {
        let users = getDatosUsuariosLocalStorag()
        if (!esElegibleDescuentoSRI()) {
            if (checkds.current) {
                checkds.current.checked = false
            }
            UpdateDatosUsuariosLocalStorag({ discapacidad: 'No' })
            usedispatch(setToastes({
                show: true,
                message: "Este cliente no califica para descuento por SRI (discapacidad/tercera edad)",
                color: 'bg-warning',
                estado: "Descuento no habilitado"
            }))
            ListaPrecioset(GetValores())
            return
        }

        const siguienteValor = users.discapacidad == 'No' ? 'Si' : 'No'
        if (checkds.current) {
            checkds.current.checked = siguienteValor == 'Si'
        }
        UpdateDatosUsuariosLocalStorag({ discapacidad: siguienteValor })
        usuario.discapacidad = siguienteValor
        ListaPrecioset(GetValores())
    }
    function Eliminar(e) {
        let user = getDatosUsuariosLocalStorag()
        let array = e.localidaEspacio["typo"] != "correlativo" ? listaEliminasillas(e.id) : ''
        e.localidaEspacio["typo"] != "correlativo" ? quitarsilla({ "array": [...array] }).then(ouput => {
            usedispatch(clearSillas(e))
            EliminarSillaLocal(e.localidad)
            $("div." + e.localidaEspacio["idcolor"] + "silla").removeClass("seleccionado").addClass("disponible");
        }
        ).catch(err => logWithCallback(err)) :
            correlativosadd(
                {
                    "id": e.id,
                    "estado": "disponible",
                    "mas": "eliminar",
                    "cedula": user.cedula,
                    "cantidad": e.cantidad
                }
            ).then(oupt => {
            }).catch(err => {

            })
        window.gtag('event', 'remove_from_cart', {
            currency: "USD",
            value: (e.valor * e.cantidad),
            items: [
                {
                    item_id: e.localidad,
                    item_name: e.id,
                    affiliation: "Moald Carrito",
                    price: e.valor,
                    quantity: e.cantidad
                }
            ]
        });
        e.localidaEspacio["typo"] == "correlativo" ? usedispatch(clearSillas(e)) : ''
        EliminarByStora(e.localidad)
        e.localidaEspacio["typo"] == "correlativo" ? EliminarSillaLocal(e.localidad) : ''
        setDetalle(getVerTienda())
        ListaPrecioset(GetValores())
        hideAlert()
    }
    function abrirlocalidad() {
        setSpiner("d-none")
        usedispatch(setModal({ nombre: "Modallocalida", estado: '' }))
        return
    }
    useEffect(() => {
        // BUG: esto llamaba a ListarMetodosPagoActivos() SIN codigoEvento --
        // el backend entonces resuelve aplica_comision_boleto=true para TODOS
        // los metodos (sin evento no hay restriccion que aplicar), y como este
        // modal se monta ANTES/junto con ModalPago/ModalFormasPago, pisaba en
        // sessionStorage[ComisionesPago] la respuesta SI escopeada por evento
        // de esos otros modales -- la comision de la ticketera terminaba
        // cobrandose en TODOS los metodos aunque el evento restringiera a solo
        // uno (ver ComisionBoletoPanel.js). Mismo patron que ModalPago.js /
        // ModalFormasPago.js: sacar el codigoEvento de "infoevento".
        const codigoEvento = JSON.parse(sessionStorage.getItem("infoevento") || "{}")?.codigoEvento
        ListarMetodosPagoActivos(codigoEvento).then((resp) => {
            if (Array.isArray(resp?.data)) {
                sessionStorage.setItem(ComisionesPago, JSON.stringify(resp.data))
                setMetodosActivos(resp.data.map((g) => g.metodo))
            }
        }).catch(() => {})
    }, [])

    // true si el metodo esta permitido para este vendedor (o si todavia no
    // se sabe / fallo la consulta -- en ese caso no se oculta nada, para no
    // dejar al vendedor sin ninguna opcion por un problema de red).
    const metodoPermitido = (metodo) => metodosActivos === null || metodosActivos.includes(metodo)

    useEffect(() => {
        if (!CODIGO) return
        AxioBoleteria.get("api/v1/imagenBloques/" + CODIGO).then(({ data }) => {
            if (data?.success && data?.imagen_bloques) setImagenBloquesDB(data.imagen_bloques)
        }).catch(() => {})
    }, [CODIGO])

    useEffect(() => {
        let user = getDatosUsuariosLocalStorag()
        setDetalle(getVerTienda())
        setListarCarritoDetalle(getVerTienda())
        //
        if (clienteInfo() != null) {
            checkds.current.checked = (user.discapacidad == 'Si')
        }
        let metodoPago = GetMetodo()
        if (["PagoPlux", "Payphone", "Duna"].includes(metodoPago)) {
            metodoPago = null
        }
        if (metodoPago != null) {
            setChecked({
                Fisico: metodoPago == "Efectivo-Local" ? "Efectivo-Local" : "",
                Efectivo: metodoPago == "Efectivo" ? "Efectivo" : "",
                Tarjeta: metodoPago == "Tarjeta" ? "Tarjeta" : "",
                Deposito: metodoPago == "Deposito" ? "Deposito" : "",
                Transferencia: metodoPago == "Transferencia" ? "Transferencia" : ""
            })
            setSelecte(metodoPago)
        } else {
            handelMetodopago({ name: 'Tarjeta' }, "Tarjeta")
        }
        setCheck(false)

        ListaPrecioset(GetValores())
        let asientos = JSON.parse(sessionStorage.getItem("asientosList"))
        asientos != null ? usedispatch(cargarsilla(asientos)) : ''
        // MAPA: pinta cada localidad del svg con su color.
        // El svg (svgseleccion.js ~2.8MB) es lazy: la 1ra vez que se abre un
        // evento todavia se esta descargando cuando corre este efecto, asi que
        // los #path aun no existen y no se pintaba nada -> "localidades sin
        // color" (y la 2da vez ya andaba porque el chunk quedaba cacheado).
        // Ahora en vez de pintar una sola vez se reintenta hasta que el svg
        // este montado, o se corta a los ~6s.
        const pintarLocalidades = () => {
            if (!precios.pathmapa || precios.pathmapa.length === 0) {
                console.warn("[MAPA] precios.pathmapa vacio: aun no llegan los datos del mapa")
                return true // nada que pintar, no tiene sentido reintentar
            }
            let pintadas = 0
            precios.pathmapa.forEach((e) => {
                const el = $("#" + e.path)
                if (el.length === 0) return // el svg todavia no monto ese path
                el.attr("class", e.id + "  disponible ")
                el.attr("fill", e.fill)
                // .css sobrescribe fill inline para SVGs custom que tienen fill en style attribute
                el.css("fill", e.fill)
                pintadas++
            })
            console.log("[MAPA] localidades pintadas:", pintadas, "de", precios.pathmapa.length)
            return pintadas === precios.pathmapa.length
        }
        // Pinta el mapa Y engancha los listeners (hover/click) del svg. Los dos
        // dependen de que el svg lazy ya este montado, por eso van juntos y se
        // reintentan: antes los listeners se enganchaban una sola vez, cuando el
        // svg todavia no existia, y las localidades quedaban pintadas pero sin
        // poder seleccionarse.
        let listenersSvgPuestos = false
        const aplicarMapa = () => {
            const pintado = pintarLocalidades()
            if (pintado) engancharListenersSvg()
            return pintado
        }
        console.log("[MAPA] pintar localidades -> pathmapa:", precios.pathmapa.length)
        if (!aplicarMapa()) {
            let intentos = 0
            const reintentoMapa = setInterval(() => {
                intentos++
                if (aplicarMapa() || intentos >= 30) {
                    if (intentos >= 30) console.warn("[MAPA] no se pudo preparar el mapa: el svg no monto tras ~6s")
                    clearInterval(reintentoMapa)
                }
            }, 200)
        }
        Listarticketporestado(user.cedula).then(oupt => {
            usedispatch(updateboletos({
                disponibles: sleccionlocalidad.disponibles,
                proceso: 0,
                pagados: oupt.data.filter(e => e.codigoEvento == sessionStorage.getItem(Eventoid) && e.estado.toLowerCase() == "Pagado" || e.estado != null && e.estado.toLowerCase() == "reservado").length,
                inpagos: oupt.data.filter(e => e.codigoEvento == sessionStorage.getItem(Eventoid) && e.estado != null && e.estado.toLowerCase() == "reservado").length
            }))

        }).catch(err => {
            logWithCallback(err)
        })
        function engancharListenersSvg() {
        if (listenersSvgPuestos) return
        const path = document.querySelectorAll('path.disponible,polygon.disponible,rect.disponible,ellipse.disponible,polyline.disponible')
        if (path.length === 0) return // el svg todavia no monto: se reintenta luego
        listenersSvgPuestos = true
        modalshow.nombre == "ModalCarritov" ? path.forEach(E => {
            E.addEventListener("mouseover", function () {
                let consulta = precios.precios.find((F) => F.idcolor == this.classList[0])
                let tooltip = document.getElementById("tooltip");
                let localidadnombre = document.getElementById("nomLocalidad")
                let precioLocalidad = document.getElementById("prelocalidad")
                let header = document.getElementById("precioscomp")
                let idheadr = document.getElementById("header")
                localidadnombre.innerHTML = `${consulta.localidad}`;
                precioLocalidad.innerHTML = `$${consulta.precio_tarjeta} `;
                //localidadnombre.style.backgroundColor = `${consulta.color}`
                tooltip.style.backgroundColor = `${consulta.color}`
                tooltip.style.borderColor = 'white';
                tooltip.style.color = 'white';
                //tooltip.innerHTML = "text";
                tooltip.style.display = "block";
                // tooltip.style.left = evt.pageX + 5 + 'px';
                header.style.backgroundColor = consulta.color;

                // tooltip.style.top = evt.pageY + 5 + 'px';
                // this.setAttribute("fill", "green");
            });

            E.addEventListener("mouseout", function () {
                var tooltip = document.getElementById("tooltip");
                tooltip.style.display = "none";
                //this.setAttribute("fill", this.getAttribute("original-fill"));
            });
            E.addEventListener("click", async function () {
                if (!hasExecuted) {
                    let consulta = precios.precios.find((F) => F.idcolor == this.classList[0])
                    // Zona del mapa sin localidad con precio en este evento: no hace nada (antes fallaba
                    // al leer consulta.espacio y dejaba el "cargando" puesto)
                    if (!consulta) return
                    // Localidad con opciones de compra (Individual / promocion): se elige antes de las sillas
                    consulta = await pedirOpcion(consulta)
                    if (!consulta) return

                    logWithCallback(consulta)
                    if (sleccionlocalidad.pagados >= 10) {
                        usedispatch(setToastes({
                            show: true,
                            message: "Están en proceso, o completaste la cantidad de compra",
                            color: 'bg-primary',
                            estado: "Has alcanzado el límite de boletos por evento"
                        }))
                        return
                    }
                    else {
                        hasExecuted = true
                        setSpiner("")
                        logLocalidadDebug("seleccion_mapa_click", {
                            consulta,
                            servicio: "localidaandespacio",
                            params: { espacio: consulta.espacio, idcolor: consulta.idcolor }
                        })
                        localidaandespacio(consulta.espacio, consulta.idcolor).then(ouput => {
                            logLocalidadDebug("respuesta_servicio_mapa", {
                                success: !!ouput,
                                totalRegistros: ouput?.data?.length || 0,
                                tipos: [...new Set((ouput?.data || []).map((x) => x.typo))]
                            })
                            let color = precios.pathmapa.filter((E) => E.id == consulta.idcolor)
                            let nuevoObjeto = []
                            if (ouput.data.find(e => e.typo == "fila")) {
                                ouput.data.forEach(x => {
                                    if (!nuevoObjeto.some(e => e.fila == x.fila)) {
                                        nuevoObjeto.push({ fila: x.fila, asientos: [{ silla: x.silla, estado: x.estado, idsilla: x.id }] })
                                    }
                                    else {
                                        let indixe = nuevoObjeto.findIndex(e => e.fila == x.fila)
                                        nuevoObjeto[indixe].asientos.push({
                                            silla: x.silla, estado: x.estado, idsilla: x.id
                                        })
                                    }
                                })
                                usedispatch(cargarmapa(color))
                                usedispatch(settypo({ nombre: precios.mapa, typo: consulta.tipo, precio: { ...consulta } }))
                                usedispatch(filtrarlocali(nuevoObjeto))
                                sessionStorage.seleccionmapa = JSON.stringify(consulta)
                                setSpiner("d-none")
                                abrirlocalidad()
                                //break
                                return
                            } else if (ouput.data.find(e => e.typo == "mesa")) {
                                ouput.data.forEach(x => {
                                    if (!nuevoObjeto.some(e => e.fila == x.fila)) {
                                        nuevoObjeto.push({ fila: x.fila, Mesas: [] })
                                    }
                                })
                                nuevoObjeto.length > 0 ? ouput.data.forEach(x => {
                                    let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                                    if (nuevoObjeto[index].Mesas.findIndex(z => z.mesa == x.mesa) == -1) {
                                        nuevoObjeto[index].Mesas.push({ mesa: x.mesa, asientos: [] })
                                    }
                                }) : ''
                                nuevoObjeto.length > 0 ? ouput.data.forEach(x => {
                                    let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                                    let sillas = nuevoObjeto[index].Mesas.findIndex(y => y.mesa == x.mesa)
                                    nuevoObjeto[index].Mesas[sillas].asientos.push({
                                        silla: x.silla, estado: x.estado, idsilla: x.id
                                    })
                                }) : ''
                                usedispatch(cargarmapa(color))
                                usedispatch(settypo({ nombre: precios.mapa, typo: consulta.tipo, precio: { ...consulta } }))
                                usedispatch(filtrarlocali(nuevoObjeto))
                                sessionStorage.seleccionmapa = JSON.stringify(consulta)
                                setSpiner("d-none")
                                abrirlocalidad()
                                return
                            }
                            else if (ouput.data.find(e => e.typo == "correlativo")) {
                                usedispatch(cargarmapa(color))
                                usedispatch(settypo({ nombre: precios.mapa, typo: consulta.tipo, precio: { ...consulta } }))
                                usedispatch(filtrarlocali(ouput.data.filter(e => e.cedula != "" && e.cedula != null)))
                                ouput.data.filter(e => e.estado == null || e.estado.toLowerCase() == "disponible").length == 0 ? usedispatch(setToastes({
                                    show: true,
                                    message: "Estan en proceso o vendidos",
                                    color: 'bg-primary',
                                    estado: "Esta loclidad no tiene disponibles  "
                                })) : ''
                                usedispatch(updateboletos({
                                    disponibles: ouput.data.filter(e => e.estado == null || e.estado.toLowerCase() == "disponible").length,
                                    proceso: ouput.data.filter(e => e.estado != null && e.estado.toLowerCase() == "reservado" && usuario.cedula).length,
                                    pagados: sleccionlocalidad.pagados,
                                    inpagos: sleccionlocalidad.inpagos
                                }))
                                sessionStorage.seleccionmapa = JSON.stringify(consulta)
                                setSpiner("d-none")
                                abrirlocalidad()
                                return

                            }
                            // MAPA: no entro a ningun tipo (fila / mesa / correlativo).
                            // Aca se queda el spinner girando y no abre nada.
                            console.warn("[MAPA] localidad numerada sin tipo reconocido -> no abre. tipos:", [...new Set((ouput?.data || []).map((x) => x.typo))])
                            setSpiner("d-none")
                            return
                        }
                        ).catch(err =>

                            {
                                console.error("[ModalCarritov][error_servicio_mapa]", {
                                    servicio: "localidaandespacio",
                                    params: { espacio: consulta?.espacio, idcolor: consulta?.idcolor },
                                    error: err
                                })
                                logWithCallback(err)
                            }

                        )

                        return
                    }
                }
            })

        }) : ''
        }
    }, [modalshow.nombre == "ModalCarritov" ? true : false])
    // Opciones de compra de la localidad (Evento -> Localidades y asientos): Individual o una promocion sobre las
    // mismas sillas. Devuelve la localidad con la opcion aplicada, o null si cancela.
    function pedirOpcion(precio) {
        const opciones = opcionesDe(precio)
        if (!precio || !opciones.length || precio.modalidad_elegida) return Promise.resolve(precio)
        const delCarrito = opcionDelCarrito(precio, getVerTienda())
        if (delCarrito) return Promise.resolve(delCarrito)
        return new Promise((resolve) => {
            const elegir = (op) => { setAlert(null); resolve(op === undefined ? null : aplicarOpcion(precio, op)) }
            setAlert(
                <SweetAlert custom showConfirm={false} showCancel={false} closeOnClickOutside={false} title={precio.localidad}
                    onConfirm={() => {}} onCancel={() => elegir(undefined)}>
                    <p className="mb-2">¿Cómo quieres comprar?</p>
                    <div className="d-grid gap-2">
                        <button className="btn btn-outline-primary" onClick={() => elegir(null)}>{textoOpcion(precio, null)}</button>
                        {opciones.map((op) => (
                            <button key={op.codigo} className="btn btn-primary" onClick={() => elegir(op)}>{textoOpcion(precio, op)}</button>
                        ))}
                        <button className="btn btn-link" onClick={() => elegir(undefined)}>Cancelar</button>
                    </div>
                </SweetAlert>
            )
        })
    }
    async function Abririlocalfirt(eOriginal) {
        const e = await pedirOpcion(eOriginal)
        if (!e) return
        if (e.idcolor == 4) {
            usedispatch(setToastes({
                show: true,
                message: "Esta localidad ya no tiene Disponibilidad",
                color: 'bg-primary',
                estado: "Todos ocupados"
            }))
            return
        }
        if (sleccionlocalidad.pagados >= 10) {
            usedispatch(setToastes({
                show: true,
                message: "Están en proceso, o llegaste al limite de compra",
                color: 'bg-primary',
                estado: "Has alcanzado el límite de boletos por evento"
            }))
            return
        }
        else {
            let user = getDatosUsuariosLocalStorag()
            let indexLocalidad = precios.precios.findIndex((item) => item.id == e.id)
            let pathPorColor = e.color ? precios.pathmapa.find((item) => item.fill == e.color) : null
            let pathPorIndice = indexLocalidad > -1 ? precios.pathmapa[indexLocalidad] : null
            let localidadId = e.idcolor ? e.idcolor : (e.id_localidad ? e.id_localidad : (pathPorColor ? pathPorColor.id : (pathPorIndice ? pathPorIndice.id : e.id)))
            let espacioId = e.espacio ? e.espacio : (e.id_espacio ? e.id_espacio : (pathPorColor ? pathPorColor.espacio : (pathPorIndice ? pathPorIndice.espacio : (precios.pathmapa.length > 0 ? precios.pathmapa[0].espacio : null))) )
            let localidadSeleccionada = {
                ...e,
                idcolor: localidadId,
                espacio: espacioId,
                typo: e.tipo ? e.tipo : (e.typo ? e.typo : e.mesas_array)
            }
            // Localidad sin zona en el mapa (fuera del mapa): id de reemplazo SOLO con el id de la localidad.
            // Antes llevaba precios.mapa, que en un mapa guardado en la BD es TODO el SVG: el id quedaba con
            // "<", '"', "=" y al pintarlo jQuery fallaba ("Syntax error, unrecognized expression") y la
            // pagina quedaba en blanco (evento GIRA MIMANDOTE, localidad GENERAL X2).
            let fallbackPathId = `auto-loc-${String(localidadId || '0').replace(/[^a-zA-Z0-9_-]/g, '')}`
            setSpiner("")
            if (!localidadId || !espacioId) {
                setSpiner("d-none")
                usedispatch(setToastes({
                    show: true,
                    message: "No se encontró la configuración completa de la localidad",
                    color: 'bg-danger',
                    estado: "Intenta nuevamente o verifica la localidad"
                }))
                return
            }
            let consulta = precios.precios.find((F) => F.idcolor == localidadId || F.id == localidadId)
            let color = precios.pathmapa.filter((E) => E.id == localidadId)
            let colorLocalidad = color.length > 0 ? color : [{
                path: fallbackPathId,
                id: localidadId,
                fill: e.color ? e.color : '#a12121',
                espacio: espacioId
            }]
            window.gtag("event", "view_item", {
                event_category: 'E-Commerce',
                currency: "USD",
                value: consulta ? consulta.precio_normal : localidadSeleccionada.precio_normal,
                items: [
                    {
                        item_id: consulta ? consulta.id : localidadSeleccionada.id,
                        item_name: consulta ? consulta.localidad : localidadSeleccionada.localidad,
                        affiliation: "Mas",
                        index: precios.precios.findIndex((F) => F.idcolor == localidadId || F.id == localidadId),
                        item_brand: "Google",
                        price: consulta ? consulta.precio_normal : localidadSeleccionada.precio_normal,
                        "cantidad": 1
                    }
                ]
            });
            logLocalidadDebug("seleccion_lista_localidades", {
                localidad: localidadSeleccionada,
                servicio: "localidaandespacio",
                params: { espacio: espacioId, idcolor: localidadId }
            })
            localidaandespacio(espacioId, localidadId).then(ouput => {
                logLocalidadDebug("respuesta_servicio_lista", {
                    success: !!ouput,
                    totalRegistros: ouput?.data?.length || 0,
                    tipos: [...new Set((ouput?.data || []).map((x) => x.typo))]
                })
                let nuevoObjeto = []
                if (ouput.data.find(e => e.typo == "fila")) {
                    ouput.data.forEach(x => {
                        if (!nuevoObjeto.some(e => e.fila == x.fila)) {
                            nuevoObjeto.push({ fila: x.fila, asientos: [{ silla: x.silla, estado: x.estado, idsilla: x.id }] })
                        }
                        else {
                            let indixe = nuevoObjeto.findIndex(e => e.fila == x.fila)
                            nuevoObjeto[indixe].asientos.push({
                                silla: x.silla, estado: x.estado, idsilla: x.id
                            })
                        }
                    })
                    usedispatch(cargarmapa(colorLocalidad))

                    usedispatch(settypo({ nombre: precios.mapa, typo: "fila", precio: { ...localidadSeleccionada, typo: "fila" } }))
                    usedispatch(filtrarlocali(nuevoObjeto))
                    sessionStorage.seleccionmapa = JSON.stringify(localidadSeleccionada)
                    abrirlocalidad()

                }
                else if (ouput.data.find(e => e.typo == "mesa")) {
                    ouput.data.forEach(x => {
                        if (!nuevoObjeto.some(e => e.fila == x.fila)) {
                            nuevoObjeto.push({ fila: x.fila, Mesas: [] })
                        }
                    })
                    nuevoObjeto.length > 0 ? ouput.data.forEach(x => {
                        let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                        if (nuevoObjeto[index].Mesas.findIndex(z => z.mesa == x.mesa) == -1) {
                            nuevoObjeto[index].Mesas.push({ mesa: x.mesa, asientos: [] })
                        }
                    }) : ''
                    nuevoObjeto.length > 0 ? ouput.data.forEach(x => {
                        let index = nuevoObjeto.findIndex(z => z.fila == x.fila)
                        let sillas = nuevoObjeto[index].Mesas.findIndex(y => y.mesa == x.mesa)
                        nuevoObjeto[index].Mesas[sillas].asientos.push({
                            silla: x.silla, estado: x.estado, idsilla: x.id
                        })
                    }) : ''
                    logWithCallback(precios)
                    usedispatch(cargarmapa(colorLocalidad))
                    usedispatch(settypo({ nombre: precios.mapa, typo: "mesa", precio: { ...localidadSeleccionada, typo: "mesa" } }))
                    usedispatch(filtrarlocali(nuevoObjeto))
                    sessionStorage.seleccionmapa = JSON.stringify(localidadSeleccionada)
                    abrirlocalidad()
                }
                else if (ouput.data.find(e => e.typo == "correlativo")) {
                    usedispatch(updateboletos({
                        disponibles: ouput.data.filter(e => e.estado == null || e.estado.toLowerCase() == "disponible").length,
                        proceso: ouput.data.filter(e => e.estado != null && e.estado.toLowerCase() == "reservado" && usuario.cedula).length,
                        pagados: sleccionlocalidad.pagados,
                        inpagos: sleccionlocalidad.inpagos
                    }))
                    usedispatch(filtrarlocali(ouput.data.filter(e => e.cedula != " " && e.cedula != null)))
                    ouput.data.filter(e => e.estado == null || e.estado.toLowerCase() == "disponible").length == 0 ?
                        usedispatch(setToastes({
                            show: true,
                            message: "Estan en proceso o vendidos",
                            color: 'bg-primary',
                            estado: "Esta loclidad no tiene disponibles  "
                        })) : ''
                    usedispatch(cargarmapa(colorLocalidad))
                    usedispatch(settypo({ nombre: precios.mapa, typo: "correlativo", precio: { ...localidadSeleccionada, typo: "correlativo" } }))
                    sessionStorage.seleccionmapa = JSON.stringify(localidadSeleccionada)
                    abrirlocalidad()
                    return
                }
            }
            ).catch(err =>
            {
                setSpiner("d-none")
                console.error("[ModalCarritov][error_servicio_lista]", {
                    servicio: "localidaandespacio",
                    params: { espacio: espacioId, idcolor: localidadId },
                    error: err
                })
                logWithCallback(err)
            }
            )
        }
    }
    let hasExecuted = false;

    function cerrar() {
        let user = getDatosUsuariosLocalStorag()

        window.gtag('event', 'cerrar carrito', {
            event_category: 'something_something',
            event_label: 'test',
            value: user.cedula
        });
        handleClosesop()
        hideAlert()
    }
    const successAlert = () => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                closeOnClickOutside={false}
                showCancel={false}
                showConfirm={false}
                closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
            >
                <div >
                    <div className='col-12 pb-3'>
                        <img src={atencion} className="img-fluid"
                            style={{
                                height: 100
                            }}
                        ></img>
                    </div>
                    <div className="px-2">
                        <h6 className=' col-9 col-md-12  mx-auto' style={{
                            fontWeight: "bold",
                            fontSize: "1.0rem"
                        }}>¿Quieres abandonar tu proceso de compra?</h6>
                        <p> No puedes guardar tu proceso y continuar luego. Si, abandonas perderás tus reservas
                        </p>
                        <p>  </p>
                    </div>


                </div>
                <div className='d-flex  justify-content-around py-4'>
                    <div>
                        <button className='btn btn-outline-danger  rounded-6' onClick={() => hideAlert()}>

                            <span style={{
                                fontWeight: "bold"
                            }}>Cancelar</span>
                        </button>
                    </div>
                    <div>
                        <button className=' btn btn-warning rounded-5' onClick={() => cerrar()} >
                            <span style={{
                                fontWeight: "bold"
                            }}> Aceptar</span>
                        </button>
                    </div>

                </div>

            </SweetAlert>
        )
    }
    const clickt = () => {
        usedispatch(setToastes({
            show: true,
            message: "Toca el palco requerido en el mapa",
            color: 'bg-primary',
            estado: "Selecciona tu compra en el mapa"
        }))
    }

    const EliminaLocalidad = (e) => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                closeOnClickOutside={false}
                showCancel={false}
                showConfirm={false}
                closeAnim={{ name: 'hideSweetAlert', duration: 500 }}
            >
                <div className='col-12 pb-3'>
                    <img src={atencion} className="img-fluid"
                        style={{
                            height: 100
                        }}
                    ></img>
                </div>
                <div>
                    <h5 style={{
                        fontWeight: "bold"
                    }}>
                        Estas Seguro?
                    </h5>
                </div>

                <div className="px-2" > Se Borraran Todas las selecciones de esta Localidad </div>
                <div className='d-flex  justify-content-around py-4 px-2'>
                    <div>
                        <button className='btn btn-outline-danger  rounded-6' onClick={() => hideAlert()}>

                            <span style={{
                                fontWeight: "bold"
                            }}>Cancelar</span>
                        </button>
                    </div>
                    <div>
                        <button className=' btn btn-warning rounded-5' onClick={() => Eliminar(e)} >
                            <span style={{
                                fontWeight: "bold"
                            }}> Aceptar</span>
                        </button>
                    </div>

                </div>
            </SweetAlert>
        );
    }
    const hideAlert = () => {
        setAlert(null);
    };
    return (
        <>
            {alert}
            <Modal
                show={modalshow.nombre == "ModalCarritov" ? true : false}
                size="lg"
                fullscreen={'md-down'}
                className="modalCarrito"
                centered
            >
                <Modal.Header className="pb-2  bg-dark  text-light">
                    <div className="d-flex col-6 justify-content-between  align-items-center " >
                        <div>
                            <h5 className="modal-title text-center justify-content-center"
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "1.2em"
                                }}>BOLETERÍA </h5>
                        </div>
                    </div>
                    <div className=" float-end ">
                        <div className="d-none d-md-block d-xl-block" >
                            {intervalo ? <h5 className="modal-title text-center justify-content-center"
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "1.2em",
                                    fontSizeAdjust: 0.5
                                }}>
                                Tiempo restante para la compra <span className="text-danger"
                                    style={{
                                        fontSize: '1.2em',
                                        fontWeight: "bold"
                                    }}
                                >{intervalo}</span> </h5> : ''}
                        </div>
                        <div className="d-block d-sm-block d-md-none " >
                            {intervalo ? <h5 className="modal-title text-center justify-content-center"
                                style={{
                                    fontWeight: "bold",
                                    fontSize: "0.8em",
                                    fontSizeAdjust: 0.5
                                }}>
                                Tiempo restante para la compra <span className="text-danger"
                                    style={{
                                        fontSize: '0.9em',
                                        fontWeight: "bold"
                                    }}
                                >{intervalo}</span> </h5> : ''}
                        </div>
                    </div>
                    <button type="button" className="close txt-white" onClick={detalle.length > 0 ? successAlert : cerrar} >
                        X
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-wrap-reverse justify-content-center p-0 container-fluid"  >
                        <div className="col-12 pt-0  col-lg-12" >
                            <div className="  ">
                                <div className="detalles-resumen"
                                >
                                    <div className="bg-secondary d-none p-2 d-sm-block  text-light flex-table row" role="rowgroup">
                                        <div className="row text-center p-0 header" role="rowgroup">
                                            <div className="flex-row text-center col-sm" role="columnheader">Localidad</div>
                                            {/*<div className=" flex-row  text-center col-2 col-md-2" role="columnheader">Asiento</div>*/}
                                            <div className="flex-row  text-center col-2" role="columnheader">Total</div>
                                            <div className="flex-row  text-center col-2" role="columnheader">Cantidad</div>
                                            <div className="flex-row  col-sm " role="columnheader">Acciones</div>
                                        </div>

                                    </div>
                                    <div className="bg-secondary p-1  text-light flex-table row d-block d-sm-none " >

                                        <h4>Seleccionados</h4>

                                    </div>
                                    <div className="px-2  list-group-flush " style={{ maxHeight: '500px', overflowY: 'auto', overflowX: 'hidden' }}>
                                        {detalle.length > 0 ?

                                            detalle.map((e, i) => {
                                                const factorBoletos = Number(e?.localidaEspacio?.factor_boletos || e?.factor_boletos || 1)
                                                const cantidadAsientos = Number(e?.cantidad || 0)
                                                const cantidadCobro = factorBoletos > 1
                                                    ? Math.ceil(cantidadAsientos / factorBoletos)
                                                    : cantidadAsientos
                                                const totalLinea = parseFloat(e.valor || 0) * cantidadCobro
                                                return (
                                                    <div className="d-flex flex-table text-center row list-group-item" role="rowgroup" key={"items" + i}>
                                                        <div className="flex-row first  d-none d-sm-block col-sm p-0"
                                                            style={{
                                                                fontSize: "0.9em",
                                                            }} >{e.localidad}</div>
                                                        <div className="d-none d-sm-block  flex-row text-center col-2">${totalLinea.toFixed(2)}</div>
                                                        <div className="d-none d-sm-block flex-row  text-center  col-2 mx-auto justify-content-center">{e.cantidad}</div>
                                                        <div className="d-none d-sm-block d-flex d-sm-flex flex-row   mx-auto  justify-content-center col-sm">
                                                            <button className=" d-none d-sm-block  btn btn-danger  btn-sm" onClick={() => EliminaLocalidad(e)} >
                                                                <i className="fa fa-trash fa-1x"></i>
                                                            </button>
                                                            <button className=" d-none d-sm-block btn btn-primary mx-1  btn-sm " onClick={() => Abririlocalfirt(e.localidaEspacio)} >
                                                                <i className="fa fa-edit"></i>
                                                            </button>
                                                            {seleciondesillas.filter(item => item.localidad == e.localidad).length > 0 ? <button className=" d-none d-sm-block btn btn-success  btn-sm"
                                                                data-toggle="collapse" href={"#collapseExample" + i}
                                                                aria-expanded="false"
                                                                aria-controls={"#collapseExample" + i}
                                                            >
                                                                <i className="fa fa-eye fa-2xs"></i>
                                                            </button> : ''}
                                                        </div>
                                                        <div className="d-block d-sm-none col-6  col-6 d-flex flex-row ">
                                                            <div className="d-flex flex-column ">
                                                                <h5 className="card-title">{e.localidad}</h5>

                                                                <p className="card-subtitle">Valor ${e.valor}</p>
                                                                <p className="card-subtitle">Cantidad {e.cantidad}</p>
                                                                <p className="card-subtitle">Total ${totalLinea.toFixed(2)}</p>
                                                            </div>
                                                        </div>
                                                        <div className="d-block d-sm-none col-6 d-flex flex-row justify-content-center align-items-center text-center">
                                                            <button className="d-block d-sm-none btn btn-danger  btn-sm" onClick={() => EliminaLocalidad(e)} >
                                                                <i className="fa fa-trash fa-1x"></i>
                                                            </button>
                                                            <button className="d-block d-sm-none btn btn-primary mx-1  btn-sm " onClick={() => Abririlocalfirt(e.localidaEspacio)} >
                                                                <i className="fa fa-edit"></i>
                                                            </button>
                                                            {seleciondesillas.filter(item => item.localidad == e.localidad).length > 0 ? <button className="d-block d-sm-none btn btn-success  btn-sm"
                                                                data-toggle="collapse" href={"#collapseExample" + i}
                                                                aria-expanded="false"
                                                                aria-controls={"#collapseExample" + i}
                                                            >
                                                                <i className="fa fa-eye fa-2xs"></i>
                                                            </button> : ''}
                                                        </div>
                                                        <div className="collapse" id={"collapseExample" + i}>
                                                            <div className="d-flex flex-wrap">
                                                                {

                                                                    seleciondesillas.filter(item => item.localidad == e.localidad).length > 0 ?
                                                                        seleciondesillas.filter(item => item.localidad == e.localidad && item.estado == "seleccionado").map((elm, id) => {
                                                                            // BUG FIX: elm.silla viene undefined para localidades sin
                                                                            // asiento numerado (venta por cantidad, ej. "GENERAL" con
                                                                            // stepper +/-) -- .replace() sobre undefined tronaba con
                                                                            // TypeError y, al no haber ErrorBoundary, tumbaba TODO
                                                                            // ModalCarritoView a pantalla en blanco (este bloque se
                                                                            // renderiza siempre, aunque el panel "ver asientos" este
                                                                            // colapsado/oculto por CSS).
                                                                            const silla = elm.silla || ''
                                                                            return (
                                                                                <div key={id} className={silla + ' d-flex rounded-5  bg-success justify-content-center align-items-center '}
                                                                                    style={{ height: '30px', width: '60px', margin: '1px' }} >
                                                                                    <div className={'d-flex   text-white justify-content-center  '} >
                                                                                        <div className="d-flex flex-wrap justify-content-center text-center p-2">
                                                                                            <span className="mx-1" style={{ fontSize: '0.7em' }}>{silla.replace("-", " ").split(" ")[0]}</span>
                                                                                            <span style={{ fontSize: '0.7em' }}>{silla.replace("-", " ").split(" ")[1]}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                            )
                                                                        }) :
                                                                        <div className="d-flex text-center" >

                                                                        </div>
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>
                                                )
                                            })
                                            : ''
                                        }
                                        <div className="d-flex   justify-content-center my-1 row list-group-item" role="rowgroup">
                                            {/*sleccionlocalidad.inpagos > 0 ? "Tienes " + sleccionlocalidad.inpagos + " boletos por pagar" : ''*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-12  border rounded-5 pt-1 mb-2  px-0"
                            style={{ alignItems: 'stretch', lineHeight: '1', }}>
                            <div className="row ">
                                <div className="col-12  text-center">
                                    <h5 style={{ fontSize: '1.1em', fontWeight: "bold" }} >
                                        SELECCIONE LA LOCALIDAD EN EL MAPA O EN EL NOMBRE
                                    </h5>
                                    <div className="col-12 col-md-9 py-0 col-lg-10 mx-auto text-center " style={{
                                        height: "auto"
                                    }}>
                                        <div id="tooltip"
                                            style={{
                                                position: 'absolute',
                                                display: 'none',
                                                width: '135px'
                                            }}
                                        >
                                            <div className="py-2   border-bottom text-center px-0" id="header" styled={{
                                                Width: "100px",

                                            }}>
                                                <strong className="mr-auto" id="nomLocalidad"></strong>
                                            </div>
                                            <div className=" px-1 d-flex justify-content-center align-items-center">
                                                <div id="precioscomp" className="mx-1 d-none p-2 rounded-4"></div>   <p className=" mt-1" id="prelocalidad"></p>

                                            </div>
                                        </div>

                                        {modalshow.nombre == "ModalCarritov" ?
                                            (sessionStorage.getItem("eventoid") == "5UY4DT") ?

                                                precios.precios.filter(e => e.habilitar_cortesia != 0).sort((a, b) => (a.precio_normal < b.precio_normal ? 1 : -1) && (a.id > b.id ? 1 : -1)).map((elm, i) => {
                                                    return (
                                                        <div className="" onClick={() => Abririlocalfirt(elm)} key={i}  >
                                                            <Suspense fallback={null}>
                                                                <SvgselectView
                                                                    text={precios.mapa} />
                                                            </Suspense>
                                                        </div>
                                                    )
                                                })
                                                :
                                                <div style={{

                                                }}>
                                                    <Suspense fallback={null}>
                                                        <SvgselectView
                                                            text={precios.mapa} />
                                                    </Suspense>
                                                </div>
                                            : ''}
                                    </div>
                                </div>
                                {(imagenBloquesDB || EVENTOS_IMAGEN_BLOQUES[CODIGO]) ? (
                                    <div className="col-12 text-center mb-2">
                                        <button type="button" className="btn btn-outline-primary btn-sm"
                                            onClick={() => setShowImagenBloques(true)}>
                                            Ver bloques en el mapa
                                        </button>
                                        <Modal show={showImagenBloques} onHide={() => setShowImagenBloques(false)} centered size="lg">
                                            <Modal.Header closeButton>
                                                <Modal.Title>Division por bloques</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body className="text-center">
                                                <img src={imagenBloquesDB || EVENTOS_IMAGEN_BLOQUES[CODIGO]} alt="Division por bloques"
                                                    className="img-fluid" />
                                            </Modal.Body>
                                        </Modal>
                                    </div>
                                ) : null}
                                <div className="col-12 d-flex justify-content-center">
                                    <div className=" container-fluid d-flex  justify-content-between py-2  px-0 flex-wrap pb-2   align-items-center  p-0">
                                        {sessionStorage.getItem("eventoid") != "YZPQQ3" && precios.precios.length > 0 ?
                                            precios.precios.filter(e => e.habilitar_cortesia != 0).sort((a, b) => (a.precio_normal - b.precio_normal)).map((elm, i) => {
                                                return (
                                                    <div className="d-flex flex-row mx-1 mb-1 py-1 precios align-items-center" onClick={() => Abririlocalfirt(elm)} key={i}  >
                                                        <div id={"precios" + elm.id} className="mx-1  p-2 rounded-4" style={{ height: 20, width: 20, backgroundColor: elm.color }}></div>
                                                        <div className="d-flex flex-row" style={{ alignItems: 'stretch', lineHeight: '1', minWidth: '130px', maxWidth: '170px' }} >
                                                            <span className="" style={{ fontFamily: '', fontSize: '1.11em' }} >{elm.localidad} </span>
                                                            <span className="pl-1" style={{ fontFamily: '', fontSize: '1.11em' }} >${elm.precio_tarjeta} </span>
                                                        </div>
                                                    </div>
                                                )
                                            }) :
                                            <div className="container-fluid d-flex  py-2  col-12 flex-wrap pb-2 justify-content-between align-items-center px-0 p-0">

                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex  p-3 border-top  justify-content-between align-items-center">
                    <div className="d-flex  col-12 justify-content-end my-1" role="rowgroup">
                        {/*CODIGO=="CDKH71"?
                        <div>
                         <label className="form-label">Código cub country </label>
                        <input className="form-control" />
                        </div>
                        :""*/}
                    </div>
                    <div className="d-flex flex-column">
                        {clienteInfo() != null ?
                            <div className="container">
                                <input className="form-check-input" type="checkbox"
                                    ref={checkds}
                                    onChange={CambiarCheck}

                                    name="descuento" id="descuento" />
                                <label className="form-check-label" htmlFor="descuento">
                                    DESCUENTO DIS./TER. EDAD.- 50%
                                </label>
                            </div>

                            : ""}
                        {
                            clienteInfo() != null ?
                                <div>
                                    <strong> Método de pago</strong>
                                    <select className=" form-select form-select-lg" name="selctmet" value={select}
                                        onChange={(e) => handelMetodopago(e.target)}
                                    >
                                        <option value={"Tarjeta"}>
                                            Tarjeta credito
                                        </option>
                                        {metodoPermitido("Transferencia") && <option value={"Transferencia"}>
                                            Transferencia
                                        </option>}
                                        {!["vendedores", "vendedor_secundario"].includes(clienteInfo().perfil) && metodoPermitido("Efectivo-Local") && <option value={"Efectivo-Local"}>
                                            Efectivo-Local
                                        </option>}
                                        {!["vendedores", "vendedor_secundario"].includes(clienteInfo().perfil) && metodoPermitido("Tarjeta-Local") && <option value={"Tarjeta-Local"}>
                                            Tarjeta-Local
                                        </option>}
                                        {!["vendedores", "vendedor_secundario"].includes(clienteInfo().perfil) && metodoPermitido("Efectivo-QR") && <option value={"Efectivo-QR"}>
                                            Efectivo-QR
                                        </option>}
                                        <option className=" d-none" value={"Recaidacion Terceros"}>
                                            Recaidacion Terceros
                                        </option>
                                        {metodoPermitido("Efectivo") && <option className="" value={"Efectivo"}>Efectivo Speed</option>}
                                    </select>
                                </div>
                                :
                                <div>
                                    <div className=" d-none"
                                    >
                                        <strong> Método de pago</strong>

                                        <div className="form-check">
                                            <input className="v-check form-check-input" type="radio"
                                                checked={checked.Tarjeta == "Tarjeta" ? true : false}
                                                onChange={(e) => handelMetodopago({ name: e.target.name }, "Tarjeta")}
                                                name="Tarjeta" id="Tarjeta" />
                                            <label className="form-check-label" htmlFor="Tarjeta">
                                                Tarjeta-credito
                                            </label>
                                        </div>
                                        {clienteInfo() == null ?
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio"
                                                    checked={checked.Transferencia == "Transferencia" ? true : false}
                                                    onChange={(e) => handelMetodopago({ name: e.target.name }, "Transferencia")}
                                                    name="Transferencia" id="Transferencia" />
                                                <label className="form-check-label" htmlFor="Transferencia">
                                                    Transferencia
                                                </label>
                                            </div> : ""}

                                        {
                                            clienteInfo() == null ? <div className="form-check ">
                                                <input className="form-check-input" type="radio"
                                                    checked={checked.Deposito == "Deposito" ? true : false}
                                                    onChange={(e) => handelMetodopago({ name: e.target.name }, "Deposito")}
                                                    name="Deposito" id="Deposito" />
                                                <label className="form-check-label" htmlFor="Deposito">
                                                    Deposito
                                                </label>
                                            </div> : ""}


                                        {clienteInfo() == null ? <div className="form-check ">
                                            <input className="v-check form-check-input" type="radio"
                                                name="Efectivo" id="Efectivo"
                                                checked={checked.Efectivo == "Efectivo" ? true : false}
                                                onChange={(e) => handelMetodopago(e.target, "Efectivo")}
                                            />
                                            <label className="form-check-label" htmlFor="Efectivo">
                                                Efectivo
                                            </label>
                                        </div> : ""}

                                        {clienteInfo() != null ? <div className="form-check">
                                            <input className="v-check form-check-input" type="radio"
                                                name="Fisico" id="Fisico"
                                                checked={checked.Fisico == "Efectivo-Local" ? true : false}
                                                onChange={(e) => handelMetodopago(e.target, "Efectivo-Local")}
                                            />
                                            <label className="form-check-label" htmlFor="Fisico">
                                                Efectivo punto de pagos
                                            </label>
                                        </div> : ""}
                                        {/*
                                estdo != "ACTIVO" ? <div className="form-check ">
                                    <input className="form-check-input" type="radio"
                                        checked={checked.Deposito == "Deposito" ? true : false}
                                        onChange={(e) => handelMetodopago({ name: e.target.name }, "Deposito")}
                                        name="Deposito" id="Deposito" />
                                    <label className="form-check-label" htmlFor="Deposito">
                                        Reservar
                                    </label>
                                </div> : ""
                            */}
                                        {clienteInfo() != null ?
                                            <div className="form-check">
                                                <input className="form-check-input" type="radio"
                                                    checked={checked.Transferencia == "Transferencia" ? true : false}
                                                    onChange={(e) => handelMetodopago({ name: e.target.name }, "Transferencia")}
                                                    name="Transferencia" id="Transferencia" />
                                                <label className="form-check-label" htmlFor="Transferencia">
                                                    Transferencia
                                                </label>
                                            </div>
                                            : ""}


                                    </div>
                                    <div>
                                        <div className="d-flex flex-row  align-items-center " >
                                            <h4
                                                style={{
                                                    fontSize: '1.5rem',

                                                }}
                                            >SUBTOTAL:</h4>
                                            <h4
                                                style={{
                                                    fontSize: '1.5rem',
                                                    fontWeight: 'bold',
                                                }}
                                                className="px-1 text-danger total-detalle"> {listaPrecio.subtotal ? "$" + parseFloat(listaPrecio.subtotal).toFixed(2) : null}</h4>

                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                    <div className="d-flex flex-row  align-items-center d-none" >
                        <h4
                            style={{
                                fontSize: '1.5rem',

                            }}
                        >SUBTOTAL:</h4>
                        <h4
                            style={{
                                fontSize: '1.5rem',
                                fontWeight: 'bold',
                            }}
                            className="px-1 text-danger total-detalle"> {listaPrecio.subtotal ? "$" + parseFloat(listaPrecio.subtotal).toFixed(2) : null}</h4>

                    </div>
                    <div className="d-flex   bg-danger  ">
                        <div className=" text-center ">
                            <div className="py-1 d-none" >
                                <div className="input-group">
                                    <input className=" form-control-sm " placeholder="Código Barcelona"></input>
                                    <button className="btn  btn-primary"> <i className=" "></i></button>
                                </div>
                            </div>

                            {detalle.length > 0 ?
                                <button className="btn btn-primary float-right " disabled={check} onClick={handleContinuar}>Continuar </button> :
                                <button className="btn btn-primary  float-right" disabled={true} >Continuar</button>
                            }


                        </div>

                    </div>
                </Modal.Footer>
            </Modal>
            <div className={spinervi}
                style={{
                    display: 'none',
                    position: 'fixed',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: '10000'
                }}
            >

                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '10px',
                    padding: '10px',
                }}>
                    <Triangle
                        height="80"
                        width="80"
                        color="#4fa94d"
                        ariaLabel="triangle-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />
                    <h4 className='text-light'>Cargando  localidad...</h4>


                </div>
            </div>
        </>
    )
}
export default ModalCarritoView